// @flow

import { hpfetch, hpfetchWithoutContentType } from '../util';
import type { attachmentType, createAttachmentType } from '../../types';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<attachmentType>> =>
  hpfetch(`attachments/${id}/`);

export const getMany = (
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<attachmentType> =>
  hpfetch(`attachments/?limit=${limit}&offset=${offset}`);

export const uploadSingle = (attachment: createAttachmentType) => {
  const endpoint = `attachments/`;
  const form = new FormData();

  Object.entries(attachment).forEach(([key, value]) => {
    // $FlowFixMe
    form.append(key, value);
  });

  return hpfetchWithoutContentType(endpoint, {
    method: 'POST',
    body: form,
  });
};

export const update = (id: number, fields: any) =>
  hpfetch(`attachments/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(fields),
  });

export const deleteAttachment = (id: string): Promise<any> =>
  hpfetch(`attachments/${id}/`, {
    method: 'DELETE',
  });
